/**
 * Delay (ms) before opening a second modal sheet after closing the first, used
 * when swapping a read-only view sheet for its edit form. Two Radix modal
 * dialogs transitioning in the same tick can leave `document.body` with
 * `pointer-events: none` (the page goes inert). Waiting out the close animation
 * — the shadcn sheet uses `data-[state=closed]:duration-300` — lets the closing
 * dialog's scroll-lock unmount before the next opens. Slightly above 300 for
 * headroom.
 */
export const SHEET_SWAP_DELAY_MS = 320;
